/**
 * KAN-898: просмотр мусора в таблице CRM (?junk=1). Доступен тому, кому открыт
 * "Вернуть" (POST unjunk, владелец); остальным ?junk=1 в адресе игнорируется и
 * в запрос не уходит. Переключение - кнопка быстрого выбора 'junk'
 * (useCrmTablePeriod.toggleShortcut, правила адреса - lib/crmTableShortcuts).
 */
import { useSearchParams } from 'react-router-dom';
import { useCanCallApi } from '@/hooks/useApiAccess';
import { clientJunkAccessUrl } from '@/hooks/useClientJunk';
import { isCrmJunkView } from '@/lib/crmTableShortcuts';

export interface CrmJunkView {
  /** Пользователю доступен просмотр мусора. */
  available: boolean;
  /** Режим мусора включён (и доступен). */
  active: boolean;
}

export function useCrmJunkView(): CrmJunkView {
  const [params] = useSearchParams();
  const available = useCanCallApi('POST', clientJunkAccessUrl('unjunk'));
  const active = available && isCrmJunkView(params);
  return { available, active };
}
